export const minifiedBootstrapCode = `!function(){window;var n=document;i=function(){var e=n.createElement("script"),t=n.getElementsByTagName("script")[0];e.type="text/javascript",e.async=!0,e.src="${process.env.CLIENT_URI}/widget/widget-min.js",t.parentNode.insertBefore(e,t)},window.addEventListener("load",i,!1)}();`;
export const productBootstrapCode = `!function(){window;var n=document;i=function(){var e=n.createElement("script"),t=n.getElementsByTagName("script")[0];e.type="text/javascript",e.async=!0,e.src="${process.env.PRODUCT_WIDGET_URI}/widget/product.js",t.parentNode.insertBefore(e,t)},window.addEventListener("load",i,!1)}();`;

function format(str) {
  let size = -1;
  return str.replace(/\n(\s+)/g, (m, m1) => {
    if (size < 0) {
      size = m1.replace(/\t/g, '    ').length;
    }
    return `\n${m1.slice(Math.min(m1.length, size))}`;
  });
}

export function dedent(callSite, ...args) {
  if (typeof callSite === 'string') {
    return format(callSite);
  }
  if (typeof callSite === 'function') {
    return (...funcArgs) => format(callSite(...funcArgs));
  }
  const output = callSite
    .slice(0, args.length + 1)
    .map((text, i) => (i === 0 ? '' : args[i - 1]) + text)
    .join('');

  return format(output);
}

export const getWidgetCode = campaignId =>
  dedent`<script>
      window.nexleadSettings = {
        campaignId: ${campaignId}
      };
    </script>
    <script>
      ${minifiedBootstrapCode}
    </script>`;

export const getShopifyWidgetCode = campaignId =>
  dedent`<script>
    window.nexleadSettings = {
      campaignId: ${campaignId},
      store: '{your shopify store name}',
      token: '{your api token}',
      theme: 'darkBlue',
      cta: 'Buy Now!',
      title: 'On Sale Now',
    };
  </script>
  <script>
    ${productBootstrapCode}
  </script>`;



// WEBPACK FOOTER //
// ./src/helpers/widget.js